/**
 * Parses H2/H3 headings from an HTML string, injects `id` attributes for
 * in-page anchor navigation, and returns the modified HTML plus a TOC array.
 *
 * Usage:
 *   const { html, toc } = processAnchors(guide.content_html);
 *   // toc: [{ id: 'section-one', text: 'Section One', level: 'H2' }, ...]
 */
export const processAnchors = (html = '') => {
  if (!html) return { html: '', toc: [] };

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const toc = [];
  const usedIds = new Set();

  doc.querySelectorAll('h2, h3').forEach(el => {
    let base = el.textContent.trim()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]/g, '')
      .slice(0, 60);

    if (!base) return;

    let id = base;
    let n = 1;
    while (usedIds.has(id)) { id = `${base}-${n}`; n++; }
    usedIds.add(id);

    el.id = id;
    toc.push({ id, text: el.textContent.trim(), level: el.tagName });
  });

  return { html: doc.body.innerHTML, toc };
};
